import * as moment from 'moment'

window.Moment = window.moment = moment